import { useEffect } from "react";
import { useSystemSettings } from "./useSystemSettings";

/**
 * Applies SEO meta tags from system_settings.
 * Now uses the shared batch query instead of a separate Supabase call.
 */
export function useSeoConfig() {
  const { data } = useSystemSettings();

  useEffect(() => {
    const cfg = data?.seo_config;
    if (!cfg) return;

    // Per-route SEO is now handled by react-helmet-async via the <Seo> component.
    // Only apply sitewide, non-route-specific tags here so we don't overwrite per-page values.
    const setMeta = (selector: string, value: string, attr = "content") => {
      const el = document.querySelector(selector);
      if (el && value) el.setAttribute(attr, value);
    };

    setMeta('meta[name="keywords"]', cfg.keywords);
    setMeta('meta[name="author"]', cfg.author);
    setMeta('meta[property="og:site_name"]', cfg.ogSiteName);
  }, [data?.seo_config]);
}
